import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from "./locale/i18";
import { RepositoryFabric } from "../api/repositories/RepositoryFabric";
import { repositories } from "./api/Repositories";
import {Settings} from "luxon";
import VueTimeago from 'vue-timeago';
import * as Sentry from '@sentry/browser';
import { Vue as VueIntegration } from '@sentry/integrations';
import {disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks, BodyScrollOptions} from 'body-scroll-lock';
import VueGtagPlugin, { VueGtag } from "vue-gtag";
import distanceInWordsConverter from './helpers/distanceInWordsConverter';
import { AnalyticsPlugin } from '../plugins/AnalyticsPlugin'
import { FeatureAccessPlugin, FeatureAccessPluginInterface } from '../plugins/FeatureAccessPlugin'

import Component from 'vue-class-component'
import AgoraRTC from "agora-rtc-sdk-ng";

Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteLeave',
  'beforeRouteUpdate'
]);

Vue.config.productionTip = false;

Settings.defaultLocale = 'ru';

AgoraRTC.setLogLevel(4);

declare module "vue/types/vue" {
  interface Vue {
    $analytics: AnalyticsPlugin;
    $featureAccess: FeatureAccessPluginInterface;
    $repositories: RepositoryFabric;
    $disableBodyScroll: (targetElement: HTMLElement, options?: BodyScrollOptions) => void;
    $clearAllBodyScrollLocks: () => void;
    $enableBodyScroll: (targetElement: HTMLElement) => void;
    $style: Record<string, string>;
  }
  interface VueConstructor {
    $gtag: VueGtag;
    $analytics: AnalyticsPlugin;
    $featureAccess: FeatureAccessPluginInterface;
  }
}

Vue.use(VueTimeago, {
  name: 'Timeago', // Component name, `Timeago` by default
  locale: 'en', // Default locale
  locales: {
    ru: require('date-fns/locale/ru')
  },
  converter: distanceInWordsConverter
})

if (process.env.VUE_APP_SENTRY_IO_URL) {
  Sentry.init({
    dsn: process.env.VUE_APP_SENTRY_IO_URL,
    integrations: [new VueIntegration({Vue, attachProps: true})],
  });
}

Vue.use(VueGtagPlugin, {
  config: {},
  bootstrap: false
});

Vue.use(new AnalyticsPlugin(store))
Vue.use(new FeatureAccessPlugin(store))

Vue.prototype.$repositories = repositories;
Vue.prototype.$disableBodyScroll = disableBodyScroll;
Vue.prototype.$enableBodyScroll = enableBodyScroll;
Vue.prototype.$clearAllBodyScrollLocks = clearAllBodyScrollLocks;

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app');
